<template>
    <div class="page">
        <div class="top">
            <div class="top-back" @click="black">
                <img src="@/assets/userNew/icon36.png" alt="">
            </div>
            <div class="top-name">常见问题</div>
        </div>
        <div class="gtrs">
            <div class="gtr" @click="toBuyPkg('1')">卡号是什么</div>
            <div class="gtr" @click="toBuyPkg('2')">实名认证</div>
            <div class="gtr" @click="toBuyPkg('3')">实名认证卡号错误</div>
            <div class="gtr" @click="toBuyPkg('4')">怎么充值</div>
            <div class="gtr" @click="toBuyPkg('5')">上不了网（联通卡新用户）</div>
            <div class="gtr" @click="toBuyPkg('6')">怎么查询流量</div>
            <div class="gtr" @click="toBuyPkg('7')">怎么订购次月套餐，充值多笔套餐不显示</div>
            <div class="gtr" @click="toBuyPkg('8')">充值了怎么不显示，无法上网</div>
            <div class="gtr" @click="toBuyPkg('9')">无法上网（已用一段时间）</div>
            <div class="gtr" @click="toBuyPkg('10')">怎么联系客服</div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
        }
    },
    created(){
    },
    methods:{
        black(index){
            this.$router.push({
                path: "/userNew/operation",
            });
        },
        toBuyPkg(index){
            this.$router.push({
                path: "/userNew/problemDetails",
                query: {
                    id: index
                },
            });
        },
    },
}
</script>
<style lang="less" scoped>
div{
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}
.page{
	height:100%;
	background: #f7f8fa;
    .top{
        flex-direction: row;
        align-items: center;
        height: 60px;
        background-color: #ffffff;
        .top-back{
            width:60px;
            align-items: center;
            text-align: center;
            position: absolute;
            height: 60px;
            line-height: 60px;
            justify-content: center;
            img{
                width:20px;
                height:20px;
            }
        }
        .top-name{
            text-align: center;
            font-size: 17px;
            color: #06121e;
            flex: 1 1 0%;
            font-weight: bold;
        }
    }
    .gtrs{
        flex: 1;
        overflow-y: auto;
        .gtr{
            height: 50px;
            line-height: 50px;
            padding-left: 16px;
            padding-right: 40px;
            font-size: 17px;
            color: #06121E;
            background: url(../../assets/userNew/27.png) no-repeat;
            background-position: center right;
            margin-right: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
